import 'htmx-ext-ws';
import htmx from 'htmx.org';

// htmx.createWebSocket = function (url) {
//       return new WebSocket(url, ['wss', window.user_key]);
//     };
window.htmx = htmx;

